const getInvestorMatchColoums = ({ type, strongCount = 0, mediumCount = 0, lowCount = 0 }) => {
    return (
        <>
            {type === "investor"
                ? <>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Investor</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Website</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Completeness
                        <span className="tooltip-area cp" style={{ top: '1rem' }}>
                            <i className="icon">
                                <img className="h2rem" src={require(`../../images/info-icon.svg`)} alt="info" />
                                <div className="overlay-box" style={{ top: '100px' }}>
                                    <p>This score is calculated on the responsiveness of this investor to  approaches via this platform – BUT please note that a response does NOT indicate successful funding.</p>
                                </div>
                            </i>
                        </span>
                    </th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Priority Score</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Prompt Response Score</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Fit Report</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Contact Investor</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Date Contacted</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Status</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Archive</th>
                </>
                : <>
                    <th style={{ minWidth: '170px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Investor</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Website</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">
                        Fit Score
                        {/* <div className='br50px df aifs'>
                            <div className='df jcc aic mr0-5rem'>
                                <h3 className='green mr0-5rem fs13px'>{strongCount}</h3>
                                <p className='c15 fs13px'>Strong</p>
                            </div>
                            <div className='df jcc aic'>
                                <h3 className='orange mr0-5rem fs13px'>{mediumCount}</h3>
                                <p className='c15 fs13px mr0-5rem'>Medium</p>
                            </div>
                            <div className='df jcc aic'>
                                <h3 className='red mr0-5rem fs13px'>{lowCount}</h3>
                                <p className='c15 fs13px'>Low</p>
                            </div>
                        </div> */}
                    </th>
                    <th style={{ minWidth: '175px', color: '#151313CC', maxWidth: '300px' }} className="fs1rem ttu tal customHeaderBgColor">Prompt <br></br> Response Score</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">
                        Fit Report
                    </th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Contact Investor</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Date Contacted</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Status</th>
                    <th style={{ minWidth: '125px', color: '#151313CC' }} className="fs1rem ttu tal customHeaderBgColor">Archive</th>
                </>
            }
        </>
    )
}

export default getInvestorMatchColoums